var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResellerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7702 4.00016H10.7702V3.3335C10.7702 2.20016 9.90349 1.3335 8.77016 1.3335H7.43683C6.30349 1.3335 5.43683 2.20016 5.43683 3.3335V4.00016H3.43683C2.3035 4.00016 1.43683 4.86683 1.43683 6.00016V12.0002C1.43683 13.1335 2.3035 14.0002 3.43683 14.0002H12.7702C13.9035 14.0002 14.7702 13.1335 14.7702 12.0002V6.00016C14.7702 4.86683 13.9035 4.00016 12.7702 4.00016ZM6.77016 3.3335C6.77016 2.9335 7.03683 2.66683 7.43683 2.66683H8.77016C9.17016 2.66683 9.43683 2.9335 9.43683 3.3335V4.00016H6.77016V3.3335ZM13.4368 12.0002C13.4368 12.4002 13.1702 12.6668 12.7702 12.6668H3.43683C3.03683 12.6668 2.77016 12.4002 2.77016 12.0002V8.3335C3.43683 8.60016 4.1035 8.80016 4.77016 8.9335V9.3335C4.77016 9.7335 5.03683 10.0002 5.43683 10.0002C5.83683 10.0002 6.1035 9.7335 6.1035 9.3335V9.20016C6.77016 9.26683 7.43683 9.3335 8.10349 9.3335C8.77016 9.3335 9.43683 9.26683 10.1035 9.20016V9.3335C10.1035 9.7335 10.3702 10.0002 10.7702 10.0002C11.1702 10.0002 11.4368 9.7335 11.4368 9.3335V8.9335C12.1035 8.80016 12.7702 8.5335 13.4368 8.3335V12.0002Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResellerIcon);
export default __webpack_public_path__ + "static/media/resellerIcon.0909a8fce1c557283463cf357453418d.svg";
export { ForwardRef as ReactComponent };